/* eslint-disable react/jsx-props-no-spreading */
import React, { forwardRef } from 'react';
import { Form, SelectPicker } from 'rsuite';
import { FormFieldSize } from 'components/Form/CustomForm/CustomForm';
import FormControlLabel from '../../../Control/FormControlLabel';
import TextFormField from '../TextFormField';
// eslint-disable-next-line import/no-unresolved
import styles from './SelectFormField.module.scss';

/**
 * Renders a select picker
 */
const SelectFormField = forwardRef((props: any, ref: any) => {
  const {
    required,
    formValue,
    size,
    name,
    helpMessage = undefined,
    label,
    data,
    className,
  } = props;

  const groupClassName = [
    styles.formGroup,
    (size as FormFieldSize) === 'sm' ? styles.sm : styles.lg,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  if (formValue && formValue[name].toLowerCase() === 'other') {
    return (
      <>
        <Form.Group className={groupClassName} ref={ref}>
          <FormControlLabel required={required || false}>
            {label}{' '}
          </FormControlLabel>
          <div className={styles.controlWrapper}>
            <Form.Control
              className={styles.control}
              accepter={SelectPicker}
              name={name}
              data={data.picker}
              placement="bottomStart"
              searchable={data ? data.searchable || false : false}
              cleanable={false}
              block
            />
            {helpMessage ? (
              <Form.HelpText>{helpMessage}</Form.HelpText>
            ) : null}
          </div>
        </Form.Group>

        <TextFormField
          required={false}
          size={size}
          name={`${name}Other`}
          label={data.otherLabel}
          type="text"
        />
      </>
    );
  }

  return (
    <Form.Group className={groupClassName} ref={ref}>
      <FormControlLabel required={required || false}>
        {label}{' '}
      </FormControlLabel>
      <div className={styles.controlWrapper}>
        <Form.Control
          className={styles.control}
          accepter={SelectPicker}
          name={name}
          data={data.picker}
          placement="bottomStart"
          searchable={data ? data.searchable || false : false}
          cleanable={false}
          block
        />
        {helpMessage ? <Form.HelpText>{helpMessage}</Form.HelpText> : null}
      </div>
    </Form.Group>
  );
});

export default SelectFormField;
